import ActionType from '../constants/ActionType';
import { RootActionTypes } from '../../../stores/types';

export default function hideExportDialog(): RootActionTypes {
  return {
    type: ActionType.HideExportDialog,
  };
}
